import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconCategoryPackage';
/** Renders an SVG icon. */
const SvgCategoryPackage = ({
  size,
  'aria-hidden': ariaHidden,
  tone,
  UNSAFE_className,
  UNSAFE_style,
  ...rest
}: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M18.385 18.503a.75.75 0 0 1-.064 1.058L16.13 21.5l2.19 1.939a.75.75 0 0 1-.995 1.122l-2.823-2.5a.75.75 0 0 1 0-1.122l2.823-2.5a.75.75 0 0 1 1.06.064m2.585.967a.75.75 0 0 1 1.06 0l1.5 1.5a.75.75 0 0 1 0 1.06l-1.5 1.5a.75.75 0 0 1-1.06-1.06l.97-.97-.97-.97a.75.75 0 0 1 0-1.06"
      />
      <path
        fill="currentColor"
        d="m19.604 22.646.792-.792a.5.5 0 0 0 0-.707l-.792-.793a.5.5 0 0 0-.708 0l-.792.793a.5.5 0 0 0 0 .707l.792.793a.5.5 0 0 0 .708 0Z"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M12.993 4H5a1 1 0 0 0-1 1v17a1 1 0 0 0 .36.768l6 5A1 1 0 0 0 11 28h15a2 2 0 0 0 2-2V10a1 1 0 0 0-.36-.768l-6-5A1 1 0 0 0 21 4h-8.007m-.355 2 3.6 3h-4.876l-3.6-3zM6 7.135v14.397l4 3.333V10.468zM12 11v15h14V11h-6v2a1 1 0 1 1-2 0v-2zm12.238-2h-4.876l-3.6-3h4.876z"
      />
    </svg>
  );
};
SvgCategoryPackage.displayName = displayName;
export default SvgCategoryPackage;
